// extracted by mini-css-extract-plugin
export default {"nav":"NavBar_nav__aE7kl","links":"NavBar_links__nUpHk","footer":"NavBar_footer__p0p-G","version":"NavBar_version__G7bal","icon":"NavBar_icon__USKFi"};